module.exports = __webpack_public_path__ + "img/horizontal_3_5_6005.74d9b02e.png";